var map = {
	"./AvatarProfile.png": "e76f",
	"./Box_big.png": "3da3",
	"./Box_delivery.svg": "ae6c",
	"./Box_empty.svg": "4d91",
	"./Box_mini.png": "a556",
	"./Call.svg": "7514",
	"./Choosing/Arhive.svg": "3f47",
	"./Choosing/Close.svg": "6439",
	"./Choosing/Friend.svg": "5a62",
	"./Choosing/Infinite.svg": "4a1c",
	"./Choosing/NP.svg": "8725",
	"./Choosing/Share.svg": "bf9e",
	"./Converter.svg": "a176",
	"./Copy.svg": "2b79",
	"./Exchange.svg": "1df3",
	"./GooglePay_mark_800_gray.png": "1da3",
	"./Group 842.svg": "583c",
	"./Like.svg": "3b89",
	"./Money.svg": "40c9",
	"./Notification.svg": "ecf9",
	"./Question.svg": "d722",
	"./Share.svg": "19dc",
	"./Shop_mini.png": "8e59",
	"./Star.svg": "c7e8",
	"./XiaomiSmartTV.png": "dba5",
	"./a-china.svg": "7f93",
	"./a-turkey.svg": "6a77",
	"./a-usa.svg": "24ff",
	"./aPay.svg": "2ad5",
	"./add-card-referall-program.svg": "c0a8",
	"./add-card-referall-programe.svg": "63fa",
	"./affilate-img.svg": "37cb",
	"./apple-logo-w.svg": "78a5",
	"./arr-b.svg": "b61f",
	"./arr-down.svg": "0a48",
	"./arr-l-w.svg": "3f55",
	"./arr-l.svg": "a30b",
	"./arr-p-down.svg": "9ebe",
	"./arr-r.svg": "de91",
	"./auth-bg.svg": "1815",
	"./avatar.png": "690a",
	"./avatars/Avatar-10.svg": "2448",
	"./avatars/Avatar-12.svg": "83da",
	"./avatars/Avatar-13.svg": "6804",
	"./avatars/Avatar-15.svg": "971e",
	"./avatars/Avatar-16.svg": "55ad",
	"./avatars/Avatar-19.svg": "879e",
	"./avatars/Avatar-27.svg": "b990",
	"./avatars/Avatar-30.svg": "a327",
	"./avatars/Avatar-8.svg": "20f8",
	"./box.png": "42c8",
	"./buy-buttons-black.png": "aa7b",
	"./buyout-success.svg": "a9a2",
	"./close-w.svg": "c173",
	"./combineService.svg": "940b",
	"./consultService.svg": "5645",
	"./delivery-adress.png": "9900",
	"./delivery-success.svg": "6118",
	"./delivery-tracking.png": "ace6",
	"./divideService.svg": "39d1",
	"./empty-address.svg": "82e3",
	"./empty-parcel.svg": "9aad",
	"./empty-photo.svg": "e27d",
	"./ensuranceService.svg": "901a",
	"./flagCNY.svg": "4cba",
	"./flagTRY.svg": "34d4",
	"./flagUAH.svg": "cc01",
	"./flagUSD.svg": "97dd",
	"./flags.png": "6cc6",
	"./flags/China.svg": "ff35",
	"./flags/HongKong.svg": "db1d",
	"./flags/USA.svg": "080c",
	"./gPay.svg": "2b4b",
	"./ggl.svg": "94fa",
	"./gpay.png": "81ff",
	"./greenCopy.svg": "5e1b",
	"./gromophon.svg": "1d6b",
	"./happy.svg": "2792",
	"./i-china.svg": "3930",
	"./i-close-w.svg": "3e44",
	"./i-close.svg": "a873",
	"./i-down.svg": "7d6b",
	"./i-fb.svg": "b8fd",
	"./i-info.svg": "6802",
	"./i-inst.svg": "3520",
	"./i-link.svg": "02cf",
	"./i-minus.svg": "9461",
	"./i-photo.svg": "25ce",
	"./i-plus.svg": "ac1c",
	"./i-success.svg": "1bcf",
	"./i-support.svg": "d6b3",
	"./i-turkey.svg": "f993",
	"./i-usa.svg": "1cf7",
	"./konfetti.svg": "bdea",
	"./logo.png": "4ffd",
	"./logo.svg": "1ae4",
	"./logomin.png": "ac9d",
	"./new-year-xiaomi.svg": "3516",
	"./noEvents.svg": "8413",
	"./nomber_ukr.png": "2998",
	"./notify-popup-base.svg": "0bb7",
	"./onboarding-ref.svg": "5516",
	"./onboarding/0.1.png": "1b74",
	"./onboarding/0.3.png": "bd32",
	"./onboarding/0.5.png": "8bcc",
	"./onboarding/0.7.png": "174a",
	"./onboarding/1.5.png": "d4c8",
	"./onboarding/1.png": "021b",
	"./onboarding/10.png": "c596",
	"./onboarding/15.png": "1c99",
	"./onboarding/2.png": "0483",
	"./onboarding/20.png": "550e",
	"./onboarding/25.png": "d3d4",
	"./onboarding/3.5.png": "56d9",
	"./onboarding/30.png": "63f2",
	"./onboarding/5.png": "9f0c",
	"./onboarding/8.png": "4ef2",
	"./onboarding/onboarding-men.svg": "5cfe",
	"./onboarding/onboarding-plane.svg": "59de",
	"./paper.svg": "2fb3",
	"./parcel-empty.svg": "945d",
	"./parcel/Add.svg": "7216",
	"./parcel/Airplane.svg": "64b3",
	"./parcel/ArrDown.svg": "fcea",
	"./parcel/ArrRight.svg": "a940",
	"./parcel/CA.svg": "1121",
	"./parcel/Calculator.svg": "2642",
	"./parcel/China.svg": "5d1a",
	"./parcel/Close.svg": "1077",
	"./parcel/Copy.svg": "cef3",
	"./parcel/Cube.svg": "4e2b",
	"./parcel/EG.svg": "ace2",
	"./parcel/Earth.svg": "457f",
	"./parcel/Edit.svg": "309d",
	"./parcel/Group 960.svg": "93b7",
	"./parcel/Group 961.svg": "8692",
	"./parcel/Help.svg": "a64e",
	"./parcel/Info.svg": "875d",
	"./parcel/Invoice.svg": "37b3",
	"./parcel/Line.svg": "579b",
	"./parcel/Money.svg": "903f",
	"./parcel/MyAddres.svg": "aceb",
	"./parcel/Navigate.svg": "d3e1",
	"./parcel/NewPost.svg": "caf3",
	"./parcel/Notification.svg": "1757",
	"./parcel/Photo.svg": "2a55",
	"./parcel/Search.svg": "684f",
	"./parcel/Shield.svg": "8cf9",
	"./parcel/Size.svg": "9fed",
	"./parcel/Split.svg": "b16d",
	"./parcel/TaxInfo.svg": "262e",
	"./parcel/Telegram.svg": "6d74",
	"./parcel/Time.svg": "134b",
	"./parcel/UK.svg": "4c2c",
	"./parcel/USA.svg": "7414",
	"./parcel/Ukraine.svg": "8688",
	"./parcel/Union.svg": "1402",
	"./parcel/Viber.svg": "a396",
	"./parcel/Weight.svg": "a687",
	"./parcel/Whatsapp.svg": "63e7",
	"./parcel/check-gray.svg": "b570",
	"./parcel/check-green.svg": "0d7e",
	"./parcel/service01.svg": "8873",
	"./parcel/service02.svg": "75c8",
	"./parcel/service03.svg": "987a",
	"./parcel/star-black.svg": "8102",
	"./parcel/star-gray.svg": "206a",
	"./parcelManLeft.svg": "a9d2",
	"./parcelManRight.svg": "62e3",
	"./pay-logo.png": "ca9e",
	"./phone.png": "9347",
	"./photoService.svg": "0dca",
	"./plane.svg": "6b2a",
	"./profile/Earth.svg": "0c8d",
	"./profile/Exit.svg": "9142",
	"./profile/Eye.svg": "63d1",
	"./profile/EyeOff.svg": "47fd",
	"./profile/Finger.svg": "ec76",
	"./profile/Home.svg": "bae7",
	"./profile/Phone.svg": "733a",
	"./profile/RemoveUser.svg": "9583",
	"./qr-code.svg": "526f",
	"./refferal-bg.svg": "5b2b",
	"./refferal-icon.svg": "4784",
	"./refferal-img.svg": "aac7",
	"./refferal-invite.svg": "0476",
	"./repackService.svg": "218b",
	"./s-price.svg": "f30b",
	"./s-swipe.svg": "2991",
	"./s-weight.svg": "7ee2",
	"./sad.svg": "0a12",
	"./share-popup.svg": "3f0b",
	"./share-ui.png": "2b42",
	"./shoes.png": "a7c3",
	"./shop-1688.png": "dfe1",
	"./shop-6pm.png": "76cc",
	"./shop-abercrombie.png": "248c",
	"./shop-amazon.png": "5540",
	"./shop-amazoncn.png": "b886",
	"./shop-jd.png": "d451",
	"./shop-taobao.png": "546d",
	"./shop-tmall.png": "7306",
	"./shop-walmart.png": "6098",
	"./shop-zappos.png": "b053",
	"./small-logo.svg": "cbda",
	"./social/fb.png": "6b2f",
	"./social/mail.svg": "bc6d",
	"./social/more.svg": "491b",
	"./social/tg.svg": "7fda",
	"./social/vb.svg": "10cc",
	"./subtract.svg": "09a3",
	"./svgArrow1.svg": "eab5",
	"./svgArrow2.svg": "71e2",
	"./svgArrow21.svg": "dcd9",
	"./svgArrow3.svg": "a88c",
	"./tarif-check.svg": "df3d",
	"./test-product.png": "48da",
	"./tranding-up.svg": "c81b",
	"./update-bg.svg": "13a3",
	"./watch.png": "fe07",
	"./whatsapp.png": "8c62",
	"./xiaomi-bonus.jpg": "90f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";